import { useWithdrawFromPortfolioMutation } from 'hooks/mutations/Rewards/useWithdrawFromPortfolioMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import { WithdrawalRequest, WithdrawalTransferResponse } from 'types/rewards'
import { useRewardsTracking } from '../useRewardsTracking'

export const useRewardsWithdraw = ({
  isRemoveAllocation = false,
  onSuccess,
  onError,
}: {
  isRemoveAllocation: boolean
  onSuccess: (data: WithdrawalTransferResponse) => void
  onError: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()

  const { mutate: withdrawFromPortfolio, isPending: isRewardsWithdrawPending } =
    useWithdrawFromPortfolioMutation()

  const onRewardsWithdraw = (data: WithdrawalRequest) => {
    const {
      beneficiary: { walletId, amount },
    } = data

    return withdrawFromPortfolio(data, {
      onSuccess: (responseData: WithdrawalTransferResponse) => {
        trackSuccess(isRemoveAllocation ? 'removeAllocation' : 'withdraw', {
          amount: responseData.withdrawalAmount.amount,
          currency: responseData.withdrawalAmount.currency,
        })
        onSuccess(responseData)
      },
      onError: (error: BaseErrorResponse) => {
        trackError(isRemoveAllocation ? 'removeAllocation' : 'withdraw', error, {
          walletId,
          amount,
        })
        onError(error)
      },
    })
  }

  return {
    onRewardsWithdraw,
    isRewardsWithdrawPending,
  }
}
